export default __webpack_public_path__ + "static/media/three-dot-green.ba9ac6a8.svg";